import React, { useRef, useEffect, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const TinyMCEEditor = ({ value, onChange }) => {
  const editorRef = useRef(null);
  const [isEditorReady, setIsEditorReady] = useState(false);

  useEffect(() => {
    if (isEditorReady && editorRef.current) {
      const currentContent = editorRef.current.getContent();
      if (value && value !== currentContent) {
        editorRef.current.setContent(value);
      }
    }
  }, [value, isEditorReady]);

  return (
    <Editor
      apiKey="0fodw01l2jdcu0exyaqwsd8llf6ivl74oj9nc0lbfe4s3uko"
      onInit={(evt, editor) => {
        editorRef.current = editor;
        setIsEditorReady(true);
      }}
      init={{
        height: 500,
        menubar: true,
        plugins: [
          'advlist', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor',
          'pagebreak', 'searchreplace', 'wordcount', 'visualblocks', 'code', 'fullscreen',
          'insertdatetime', 'media', 'table', 'emoticons', 'help'
        ],
        toolbar:
          'undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | ' +
          'bullist numlist outdent indent | link image | print preview media fullscreen | ' +
          'forecolor backcolor emoticons | help',
        menubar: 'favs file edit view insert format tools table help',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }',
        file_picker_types: 'image',
        file_picker_callback: function (cb, value, meta) {
          if (meta.filetype === 'image') {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.onchange = function () {
              const file = input.files[0];
              const reader = new FileReader();
              reader.onload = function () {
                cb(reader.result, {
                  title: file.name
                });
              };
              reader.readAsDataURL(file);
            };
            input.click();
          }
        }
      }}
      onEditorChange={(content) => onChange(content)}
    />
  );
};

export default TinyMCEEditor;
